/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
} from './ContractSummary';
import type { PalSubmissionListEntryTimExecutionPayor } from './PalSubmissionListEntryTimExecutionPayor';
import {
    PalSubmissionListEntryTimExecutionPayorFromJSON,
    PalSubmissionListEntryTimExecutionPayorFromJSONTyped,
    PalSubmissionListEntryTimExecutionPayorToJSON,
} from './PalSubmissionListEntryTimExecutionPayor';
import type { PalSubmissionListEntryTimExecutionReportResult } from './PalSubmissionListEntryTimExecutionReportResult';
import {
    PalSubmissionListEntryTimExecutionReportResultFromJSON,
    PalSubmissionListEntryTimExecutionReportResultFromJSONTyped,
    PalSubmissionListEntryTimExecutionReportResultToJSON,
} from './PalSubmissionListEntryTimExecutionReportResult';

/**
 * Subset of TimExecution for list view (from original PAL submission)
 * @export
 * @interface PalReauthSubmissionListEntryTimExecution
 */
export interface PalReauthSubmissionListEntryTimExecution {
    /**
     * 
     * @type {PalSubmissionListEntryTimExecutionPayor}
     * @memberof PalReauthSubmissionListEntryTimExecution
     */
    payor?: PalSubmissionListEntryTimExecutionPayor;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryTimExecution
     */
    insurance_type?: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryTimExecution
     */
    reimbursement_type?: string;
    /**
     * 
     * @type {PalSubmissionListEntryTimExecutionReportResult}
     * @memberof PalReauthSubmissionListEntryTimExecution
     */
    report_result?: PalSubmissionListEntryTimExecutionReportResult;
    /**
     * 
     * @type {ContractSummary}
     * @memberof PalReauthSubmissionListEntryTimExecution
     */
    contract?: ContractSummary;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntryTimExecution interface.
 */
export function instanceOfPalReauthSubmissionListEntryTimExecution(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalReauthSubmissionListEntryTimExecutionFromJSON(json: any): PalReauthSubmissionListEntryTimExecution {
    return PalReauthSubmissionListEntryTimExecutionFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryTimExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryTimExecution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor': !exists(json, 'payor') ? undefined : PalSubmissionListEntryTimExecutionPayorFromJSON(json['payor']),
        'insurance_type': !exists(json, 'insurance_type') ? undefined : json['insurance_type'],
        'reimbursement_type': !exists(json, 'reimbursement_type') ? undefined : json['reimbursement_type'],
        'report_result': !exists(json, 'report_result') ? undefined : PalSubmissionListEntryTimExecutionReportResultFromJSON(json['report_result']),
        'contract': !exists(json, 'contract') ? undefined : ContractSummaryFromJSON(json['contract']),
    };
}

export function PalReauthSubmissionListEntryTimExecutionToJSON(value?: PalReauthSubmissionListEntryTimExecution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor': PalSubmissionListEntryTimExecutionPayorToJSON(value.payor),
        'insurance_type': value.insurance_type,
        'reimbursement_type': value.reimbursement_type,
        'report_result': PalSubmissionListEntryTimExecutionReportResultToJSON(value.report_result),
        'contract': ContractSummaryToJSON(value.contract),
    };
}

